// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__l9445","container":"Modal_container__R4LxV","modal":"Modal_modal__XgkrF"};